import React from 'react'

const ProjectTeamGovernanceMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_1037_34102)"
      fillOpacity="0.1"
    />
    <path
      d="M22.0923 11.7654C23.3576 11.7654 24.378 12.7654 24.3576 14.0103C24.3576 15.2348 23.2964 16.2756 22.0719 16.2756C20.8475 16.2756 19.8066 15.2348 19.8066 14.0103C19.827 12.7246 20.8066 11.7654 22.0923 11.7654Z"
      fill="#052351"
    />
    <path
      d="M9.88824 11.7654C11.1535 11.7654 12.1739 12.7654 12.1535 14.0103C12.1535 15.2348 11.0923 16.2756 9.86783 16.2756C8.64335 16.2756 7.60254 15.2348 7.60254 14.0103C7.60254 12.7246 8.60253 11.7654 9.88824 11.7654Z"
      fill="#052351"
    />
    <path
      d="M26.235 20.357C25.7656 18.4182 23.9289 17.0713 21.8881 17.1529C21.3167 17.1733 20.7657 17.3162 20.2759 17.5611C21.0514 18.4182 21.6228 19.4999 21.8881 20.7243C21.9493 20.9896 21.9697 21.2141 21.9902 21.4182C22.031 21.4182 22.0514 21.4182 22.0922 21.4182C23.2146 21.4182 24.3167 21.4182 25.4391 21.4182C26.235 21.4182 26.4187 21.1529 26.235 20.357Z"
      fill="#052351"
    />
    <path
      d="M10.0924 21.1325C10.3168 19.7651 10.9087 18.5407 11.7454 17.5815C11.1128 17.2754 10.4189 17.1121 9.68419 17.1529C7.74543 17.2141 6.07197 18.7039 5.72503 20.6223C5.62299 21.1529 5.82707 21.3978 6.37809 21.3978C7.54135 21.3978 8.72502 21.3978 9.88827 21.3978C9.9495 21.3978 10.0107 21.3978 10.0719 21.3978C10.0719 21.3162 10.0719 21.2345 10.0924 21.1325Z"
      fill="#052351"
    />
    <path
      d="M16.0108 21.4798C14.6843 21.4798 13.3782 21.4798 12.0517 21.4798C11.419 21.4798 11.1945 21.1941 11.2966 20.6022C11.6843 18.4186 13.5823 16.7451 15.7659 16.6839C18.0924 16.6023 20.1537 18.1329 20.6843 20.3165C20.9088 21.2145 20.6843 21.5002 19.7659 21.5002C18.521 21.4798 17.2557 21.4798 16.0108 21.4798Z"
      fill="#052351"
    />
    <path
      d="M16.0312 10.5C17.4597 10.5 18.6026 11.6224 18.6026 13.0306C18.6026 14.3979 17.3985 15.5816 16.0107 15.5816C14.623 15.5816 13.4597 14.3979 13.4597 13.0102C13.4393 11.602 14.5822 10.5 16.0312 10.5Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1037_34102"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProjectTeamGovernanceMenu
